import { Action, Module, VuexModule } from "vuex-module-decorators";
import { WorkGroup } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class WorkGroupModule extends VuexModule {
    @Action
    [WorkGroup.getWorkGroupList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/workgroup/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [WorkGroup.findPageWorkGroup](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/workgroup`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [WorkGroup.saveWorkGroup](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/workgroup/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [WorkGroup.deleteWorkGroup](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/workgroup/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}